var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileCodeEdit = function SvgFileCodeEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3147 39.6613L39.9653 59.9999L29.9653 61.9999L31.9653 51.9999L52.3147 31.6506C53.3724 30.593 54.8069 29.9988 56.3027 29.9988C57.7984 29.9988 59.233 30.593 60.2907 31.6506L60.3147 31.6746C60.84 32.1985 61.2567 32.8209 61.5411 33.5062C61.8255 34.1914 61.9718 34.926 61.9718 35.6679C61.9718 36.4099 61.8255 37.1445 61.5411 37.8297C61.2567 38.515 60.84 39.1374 60.3147 39.6613V39.6613Z",
    stroke: "#0058FF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9653 54.0107H5.96533C4.90447 54.0107 3.88705 53.5893 3.13691 52.8392C2.38676 52.089 1.96533 51.0716 1.96533 50.0107V6.01074C1.96533 4.94988 2.38676 3.93246 3.13691 3.18232C3.88705 2.43217 4.90447 2.01074 5.96533 2.01074H34.3093C34.8347 2.0105 35.355 2.11377 35.8405 2.31463C36.3259 2.5155 36.7671 2.81003 37.1387 3.18141L44.8 10.8374C45.1714 11.209 45.4659 11.6502 45.6668 12.1356C45.8676 12.6211 45.9709 13.1414 45.9707 13.6667V22.0107",
    stroke: "#80ABFF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9653 16.0107L29.9653 22.0107L23.9653 28.0107",
    stroke: "#80ABFF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9653 16.0107L9.96533 22.0107L15.9653 28.0107",
    stroke: "#80ABFF",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileCodeEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-code-edit.8ad11373.svg";
export { ForwardRef as ReactComponent };